import { BitrixVue } from "ui.vue";

BitrixVue.component("ConfigBlockCanvas", {
  data() {
    return {
      canvas: null,
      canvasWidth: null,
      canvasHeight: null,
      canvasImage: null,
      defaultImage: null,
      renderImages: [],
      currentData: null,
      currentTimer: null,
    };
  },
  props: ["canvasData", "previewDoor", "basketChange", "clearRenderImageCache"],
  methods: {
    drawRect() {
      const ctx = this.canvas;
      const context = this;
      this.clearRect();
      if (this.canvasData?.doorType?.title === "Двухстворчатая") {
        context.renderImages.length = 0;
        if (
          this.canvasData?.doorTypeConstruction !== undefined ||
          this.canvasData?.doorTypeConstruction !== null
        ) {
          if (
            this.canvasData?.doorTypeConstruction?.id === 1 ||
            this.canvasData?.doorTypeConstruction?.id === 2
          ) {
            for (const key in context.canvasData) {
              if (Object.hasOwnProperty.call(context.canvasData, key)) {
                const element = context.canvasData[key];
                if (element !== undefined && element?.canvas_two_sim) {
                  if (key === "doorFrameOutsideElement") {
                    continue;
                  }
                  if (key !== "edgeMilling") {
                    if (!context.renderImages.length) {
                      context.renderImages.push({
                        key: key,
                        canvas: element.canvas_two_sim,
                      });
                    } else {
                      let findedArr = context.renderImages.filter((item) => {
                        return item.key === key;
                      });
                      if (!findedArr.length) {
                        context.renderImages.push({
                          key: key,
                          canvas: element.canvas_two_sim,
                        });
                      } else if (
                        findedArr[0].canvas !== element.canvas_two_sim
                      ) {
                        findedArr[0].canvas = element.canvas_two_sim;
                      }
                    }
                  }
                  if (key === "edgeMilling" && element.id != 1) {
                    if (!context.renderImages.length) {
                      context.renderImages.push({
                        key: key,
                        canvas: element.canvas_two_sim,
                      });
                    } else {
                      let findedArr = context.renderImages.filter((item) => {
                        return item.key === key;
                      });
                      if (!findedArr.length) {
                        context.renderImages.push({
                          key: key,
                          canvas: element.canvas_two_sim,
                        });
                      } else if (
                        findedArr[0].canvas !== element.canvas_two_sim
                      ) {
                        findedArr[0].canvas = element.canvas_two_sim;
                      }
                    }
                  }
                }
              }
            }
          }
          if (
            this.canvasData?.doorTypeConstruction?.id === 3 ||
            this.canvasData?.doorTypeConstruction?.id === 4
          ) {
            for (const key in context.canvasData) {
              if (Object.hasOwnProperty.call(context.canvasData, key)) {
                const element = context.canvasData[key];
                if (element !== undefined && element?.canvas_two_asim) {
                  if (key === "doorFrameOutsideElement") {
                    continue;
                  }
                  if (key !== "edgeMilling") {
                    if (!context.renderImages.length) {
                      context.renderImages.push({
                        key: key,
                        canvas: element.canvas_two_asim,
                      });
                    } else {
                      let findedArr = context.renderImages.filter((item) => {
                        return item.key === key;
                      });
                      if (!findedArr.length) {
                        context.renderImages.push({
                          key: key,
                          canvas: element.canvas_two_asim,
                        });
                      } else if (
                        findedArr[0].canvas !== element.canvas_two_asim
                      ) {
                        findedArr[0].canvas = element.canvas_two_asim;
                      }
                    }
                  }
                  if (key === "edgeMilling" && element.id != 1) {
                    if (!context.renderImages.length) {
                      context.renderImages.push({
                        key: key,
                        canvas: element.canvas_two_asim,
                      });
                    } else {
                      let findedArr = context.renderImages.filter((item) => {
                        return item.key === key;
                      });
                      if (!findedArr.length) {
                        context.renderImages.push({
                          key: key,
                          canvas: element.canvas_two_asim,
                        });
                      } else if (
                        findedArr[0].canvas !== element.canvas_two_asim
                      ) {
                        findedArr[0].canvas = element.canvas;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      } else {
        for (const key in context.canvasData) {
          if (Object.hasOwnProperty.call(context.canvasData, key)) {
            const element = context.canvasData[key];
            if (element !== undefined && element !== null) {
              if (element.canvas !== undefined && element.canvas !== null) {
                if (key === "doorFrameOutsideElement") continue;
                if (!context.renderImages.length) {
                  context.renderImages.push({
                    key: key,
                    canvas: element.canvas,
                  });
                } else {
                  let findedArr = context.renderImages.filter((item) => {
                    return item.key === key;
                  });
                  if (!findedArr.length) {
                    context.renderImages.push({
                      key: key,
                      canvas: element.canvas,
                    });
                  } else if (findedArr[0].canvas !== element.canvas) {
                    findedArr[0].canvas = element.canvas;
                  }
                }
              }
            }
          }
        }
      }

      for (let i = 0; i < context.renderImages.length; i++) {
        const element = context.renderImages[i];
        if (!context.canvasData.hasOwnProperty(element.key)) {
          context.renderImages.splice(i, 1);
        } else if (context.canvasData[element.key] === undefined) {
          context.renderImages.splice(i, 1);
        } else if (typeof context.canvasData[element.key] !== "object") {
          context.renderImages.splice(i, 1);
        }
      }
      let imagesCount = this.renderImages.length;
      var filterArrr = context.renderImages.filter(function (item) {
        return item.canvas != "";
      });
      context.renderImages = filterArrr;

      if (!imagesCount && this.$store.state.previewDoor) {
        this.renderPreview(this.$store.state.previewDoor);
        return;
      }
      const $doorType =
        context.canvasData.doorType !== undefined
          ? context.canvasData.doorType
          : undefined;
      const $doorTypeConstruction =
        context.canvasData.doorTypeConstruction !== undefined
          ? context.canvasData.doorTypeConstruction
          : undefined;

      Promise.all(
        context.renderImages.map(async (item) => {
          if (item.canvas !== null) {
            const image = new Image();
            image.src = item.canvas;
            let renderedImage = await new Promise((resolve) => {
              image.addEventListener("load", () => {
                item.cashed = image;
                resolve(image);
              });
            });

            return renderedImage;
          }
        })
      )
        .then((items) => {
          items.map((item) => {
            if (
              $doorType?.title === "Двухстворчатая" &&
              $doorTypeConstruction !== null
            ) {
              if (
                $doorTypeConstruction?.id === 2 ||
                $doorTypeConstruction?.id === 4
              ) {
                ctx.save();
                ctx.scale(-1, 1);
                ctx.drawImage(
                  item,
                  image.width * -1,
                  0,
                  context.canvasWidth,
                  context.canvasHeight
                );
                ctx.restore();
              } else {
                ctx.drawImage(
                  item,
                  0,
                  0,
                  context.canvasWidth,
                  context.canvasHeight
                );
              }
            } else {
              ctx.drawImage(
                item,
                0,
                0,
                context.canvasWidth,
                context.canvasHeight,
                250,
                0,
                context.canvasWidth,
                context.canvasHeight
              );
            }
          });
        })
        .then(() => {
          let buildImage = this.$refs.drawCanvas.toDataURL();
          this.canvasImage = buildImage;
        });
    },
    clearRect() {
      const ctx = this.canvas;
      ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
    },
    setPropPosition: function (prop) {
      this.$store.dispatch("setPosition", prop);
    },
    async renderPreview(storeImages) {
      if (!storeImages.length) {
        if (basketChangeFlag) {
          this.$store.dispatch("setBasketChange", false);
        }
        return;
      }

      const ctx = this.canvas;
      const context = this;
      const basketChangeFlag = this.basketChange;
      const promise = new Promise((resolve, reject) => {
        storeImages.forEach(async (item, index) => {
          const image = new Image();
          image.src = item;
          image.addEventListener("load", async () => {
            await ctx.drawImage(
              image,
              0,
              0,
              context.canvasWidth,
              context.canvasHeight,
              250,
              0,
              context.canvasWidth,
              context.canvasHeight
            );
            if (storeImages.length - 1 === index) {
              resolve();
            }
          });
        });
      });
      promise.then(() => {
        let buildImage = this.$refs.drawCanvas.toDataURL();
        this.defaultImage = buildImage;
        this.canvasImage = buildImage;
        this.clearRect();
        if (basketChangeFlag) {
          this.$store.dispatch("setBasketChange", false);
        }
      });
    },
  },

  mounted() {
    const ctx = this.$refs.drawCanvas.getContext("2d");
    this.canvasWidth = this.$refs.drawCanvas.width;
    this.canvasHeight = this.$refs.drawCanvas.height;
    this.canvas = ctx;
    this.drawRect();
  },
  watch: {
    canvasData(val) {
      this.$store.dispatch("setImageLoadingStatus", true);
      clearTimeout(this.currentTimer);
      this.currentTimer = setTimeout(() => {
        this.$store.dispatch("setImageLoadingStatus", false);
        this.drawRect();
      }, 500);
    },
    canvasImage(val) {
      if (val) {
        this.setPropPosition({ renderImage: val });
      }
    },
    defaultImage(val) {
      if (val !== null) {
        this.$emit("previewImageChange", { previewImage: this.defaultImage });
      }
    },
    basketChange(val) {
      if (val) {
        this.renderPreview(this.previewDoor);
      }
    },
    previewDoor(val) {
      if (val !== undefined && val.length) {
        this.renderPreview(val);
      }
    },
    clearRenderImageCache(val) {
      if (val) {
        this.renderImages = [];
        this.$store.dispatch("setClearRenderImageCache", false);
      }
    },
  },

  template: `
		<canvas ref="drawCanvas" width="1000" height="1000">
				Извините, ваш браузер нет поддерживает&lt;canvas&gt; элемент.
		</canvas>
`,
});
